<template>
	<div>
		<div class="strava-table">
			<h1>Seleccione la actividad a subir</h1>
			<br />

			<v-data-table
				:headers="headers"
				:items="activities"
				class="user-list-table"
				:page="1"
				:options.sync="options"
				:loading="loading"
				hide-default-footer
				@update:options="optionsUpdate"
				disable-sort
				fixed-header=""
			>
				<template #item.selectActivity="{ item }">
					<v-btn
						class="rounded-lg"
						color="#FC4C02"
						dark
						elevation="0"
						small
						@click="openConfirmDialog(item.id)"
						>Subir actividad</v-btn
					>
				</template>

				<template #item.elapsed_time="{ item }">
					{{ item.elapsed_time | formatTime }}
				</template>

				<template #item.start_date="{ item }">
					{{ item.start_date | formatDate }}
				</template>

				<template #item.distance="{ item }">
					{{ Math.round(item.distance / 10) / 100 }} km
				</template>
				<template #no-data>No hay actividades</template>
			</v-data-table>
		</div>
		<v-col class="pa-0">
			<v-divider></v-divider>
			<v-row class="mx-0">
				<v-spacer></v-spacer>
				<v-btn
					icon
					class="ma-2"
					:disabled="options.page === 1"
					@click="previousPage"
					><v-icon>mdi-chevron-left</v-icon></v-btn
				>
				<v-btn
					icon
					class="ma-2"
					:disabled="activities.length === 0"
					@click="nextPage"
					><v-icon>mdi-chevron-right</v-icon></v-btn
				>
			</v-row>
		</v-col>
		<p>
			*Si acaba de subir la actividad a Strava, espere unos minutos y
			actualice esta página.
		</p>
		<v-row class="ma-0">
			<v-spacer></v-spacer>
			<a
				class="strava-link"
				href="https://www.strava.com/athlete/training"
				target="_blank"
				>Ver mis actividades en Strava</a
			>
		</v-row>

		<v-dialog v-model="uploadDialog" width="600" persistent>
			<v-card>
				<div class="main-content pa-8">
					<h2 class="mb-4">Subir resultados desde Strava</h2>
					<p>
						Se usará la actividad seleccionada desde Strava para
						calcular sus resultados.
					</p>

					<v-checkbox :rules="accepted" v-model="privacyAccepted">
						<template v-slot:label>
							<span
								>He leído y acepto la

								<a
									href="/politica-privacidad"
									target="_blank"
									@click.stop
									>Política de Privacidad</a
								>
								de CARRERAS KINESIA.</span
							></template
						>
					</v-checkbox>

					<v-row class="ma-0 pt-6 card-actions">
						<v-spacer></v-spacer>
						<v-btn
							class="rounded-lg"
							text
							color="error"
							@click="closeConfirmDialog"
							:disabled="uploading"
							>Cancelar</v-btn
						>
						<v-btn
							class="rounded-lg"
							elevation="0"
							@click="uploadStravaResults(selectedActivity)"
							color="success"
							:disabled="uploading || !privacyAccepted"
							:loading="uploading"
							>Subir resultados</v-btn
						>
					</v-row>
				</div>
				<div class="privacy-notice">
					<p>
						<b
							>Información básica sobre protección de datos
							(RGPD|LOPD-gdd)
						</b>
						<br /><br />

						<b>PARTE DE STRAVA</b>
					</p>
				</div>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
	import moment from "moment";
	import axios from "axios";

	export default {
		name: "UploadStravaActivity",
		props: {
			race: Object,
		},
		data() {
			return {
				activities: [],
				headers: [
					{
						align: "center",
						text: "Nombre",
						value: "name",
					},
					{ align: "center", text: "Fecha inicio", value: "start_date" },
					{ align: "center", text: "Distancia", value: "distance" },
					{ align: "center", text: "Duración", value: "elapsed_time" },
					{
						align: "center",
						text: "",
						value: "selectActivity",
					},
				],
				options: {
					itemsPerPage: 50,
					page: 1,
					sortBy: ["start_date"],
					sortDesc: [true],
				},
				loading: false,
				uploading: false,
				uploadDialog: false,
				selectedActivity: -1,
				privacyAccepted: false,

				accepted: [
					(v) =>
						v ||
						"Debe aceptar la política de privacidad para continuar",
				],
			};
		},
		watch: {
			options: {
				deep: true,
				handler() {
					this.fetchActivities();
				},
			},
		},
		filters: {
			formatDate(value) {
				return moment(value).locale("es").format("LLL");
			},
			formatTime(secs) {
				return moment.utc(secs * 1000).format("HH:mm:ss");
			},
		},
		methods: {
			async fetchActivities() {
				try {
					this.loading = true;
					const response = await axios.get("/strava/get-races", {
						params: {
							before: this.race.finishDate,
							after: this.race.startDate,
							page: this.options.page,
							perPage: this.options.itemsPerPage,
						},
					});

					this.activities = response.data.activities;
				} catch (error) {
					this.showError(error);
				} finally {
					this.loading = false;
				}
			},
			optionsUpdate(e) {
				this.options = e;
			},
			previousPage() {
				if (this.options.page > 1) {
					this.options.page--;
				}
			},
			nextPage() {
				if (this.activities.length > 0) {
					this.options.page++;
				}
			},

			openConfirmDialog(activityId) {
				this.selectedActivity = activityId;
				this.uploadDialog = true;
			},

			closeConfirmDialog() {
				this.selectedActivity = -1;
				this.uploadDialog = false;
			},

			async uploadStravaResults(activityId) {
				try {
					this.uploading = true;
					const response = await axios.post("/strava/results", {
						raceId: this.race.id,
						activityId,
					});

					if (response.status && response.status === 201) {
						this.$emit("snackbar-event", {
							color: "success",
							text: "Se han subido correctamente los resultados",
						});
					}
				} catch (error) {
					this.showError(error);
				} finally {
					this.uploading = false;
					this.$emit("uploaded");
				}
			},

			showError(error) {
				let errorToDisplay = error;
				if (error.response && error.response.data) {
					errorToDisplay = error.response.data;
				}

				if (
					error.response &&
					error.response.status &&
					error.response.status === 401
				) {
					this.$emit("strava-unauthorized");
				}

				this.$emit("snackbar-event", {
					color: "error",
					text: errorToDisplay,
				});
			},
		},
	};
</script>

<style lang="scss" scoped>
	.strava-table {
		overflow-y: scroll;
		max-height: 55vh;
	}

	.strava-link {
		color: #fc4c02;
	}

	.privacy-notice {
		background-color: #e6e6ec;
		padding: 2em;
		p {
			text-align: justify;
			font-size: 0.7em;
			margin: 0;
		}
	}
</style>